import React from "react";
import { Grid } from "@mui/material";
import { MultiSelectCheckbox } from "../../uiControls/multiSelectCheckbox";
import { MuiComboBoxWithSearch } from "../../uiControls/muiComboBoxWithSearch";

export const ReportsSelectCheckboxs = (props) => {
  const {
    isMulti,
    showInLeft,
    title,
    id,
    list,
    changeHandler,
    startUnitDisplay,
    startUnitDisabled,
    destUnitDisabled,
    selectedReportId,
  } = props;

  return (
    <Grid item sm={12} sx={{ display: "flex" }}>
      <Grid item sm={2}>
        {title}:
      </Grid>
      <Grid item sm={showInLeft ? 6 : 4}>
        {isMulti && (
          <MultiSelectCheckbox
            id={id}
            name={id}
            list={list}
            onChange={changeHandler}
            isDisabled={destUnitDisabled ? destUnitDisabled : false}
            isSelectAll={isMulti}
            selectedReportId={selectedReportId}
          />
        )}
        {!isMulti && (
          <MuiComboBoxWithSearch
            id={id}
            list={list}
            onChange={changeHandler}
            selectedReportId={selectedReportId}
          />
        )}
      </Grid>
      {!showInLeft && <Grid item sm={1}></Grid>}
      {!startUnitDisplay && <Grid item sm={4}></Grid>}
      {startUnitDisplay && (
        <Grid item sm={4}>
          <MultiSelectCheckbox
            id={"startUnit"}
            name={"startUnit"}
            list={list}
            onChange={changeHandler}
            isDisabled={startUnitDisabled}
            isSelectAll={isMulti}
            selectedReportId={selectedReportId}
          />
        </Grid>
      )}
      {!showInLeft && <Grid item sm={1}></Grid>}
    </Grid>
  );
};
